import { useEffect, useState } from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { es } from 'date-fns/locale';
import { CLINIC_TZ } from '../lib/clinicTime';

/** Reloj en vivo para el panel admin (zona Ciudad de México). */
export function useMexicoCityClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const fullLabel = formatInTimeZone(now, CLINIC_TZ, "EEEE d MMM yyyy · HH:mm:ss", {
    locale: es,
  });

  return { now, fullLabel };
}
